import { Collab, Campaign } from "@foodfluence/shared";

export const getClientIdFromCollabRequest = (collab: Collab, campaign: Campaign): string => {
    return collab?.clientID || campaign?.clientID;
}